export { default as Fv } from './Fv';
export { default as About } from './About';
export { default as Problem } from './Problem';
export { default as Choose } from './Choose';
export { default as Service } from './Service';
export { default as Works } from './Works';
export { default as Voice } from './Voice';
export { default as News } from './News';
export { default as Banner } from './Banner';
export { default as Contact } from './Contact';

// page
export { default as Head } from './Page/Head';